import { styled } from '@fluentui/react';
import { RequestProperty } from '../../presentationalComponents/RequestDetails/RequestProperty';
import { getContactUsStyles } from '../../styles/contactUsStyles';

export const RequestPropertyContainer = styled(RequestProperty, getContactUsStyles);
